module.exports = __webpack_public_path__ + "static/media/global-shoppng-12.b279952f.png";